var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgTypeform = function SvgTypeform(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 96,
    height: 101,
    viewBox: "208.5 198.5 96 101",
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#262627",
    d: "M256.88 292.76c12.276.099 26.235-.141 34.272-8.637 8.031-8.49 8.371-22.935 7.778-35.693-.594-12.797-3.018-21.07-10.819-28.837-7.757-7.721-17.209-11.293-29.86-11.842-12.651-.55-25.705.876-34.093 9.091-8.436 8.263-10.755 20.817-9.749 34.067 1.007 13.181 6.565 24.674 14.647 32.665 8.125 8.034 15.518 9.088 27.824 9.186z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#262627",
    d: "M245.136 241.976v-4.885h25.918v4.885h-10.375v27.999h-5.168v-27.999z"
  })));
};

export default SvgTypeform;